angular.module('TetherApp').directive('tetherLabel', function () {
    return {
        restrict: 'E',
        templateUrl: '/html/form/tetherLabel.html'
    }
});
